import { createPortal } from 'react-dom'

/**
 * ConfirmationModal — Bootstrap 3 styled confirmation dialog.
 *
 * Uses the existing `aps-background-mask` custom element for the backdrop
 * and standard Bootstrap 3 `.modal .modal-dialog .modal-content` structure.
 *
 * Replaces all native `window.confirm()` calls with a consistent,
 * styled modal experience.
 */

interface ConfirmationModalProps {
    title?: string
    message: string
    confirmText?: string
    cancelText?: string
    onConfirm: () => void
    onCancel: () => void
    type?: 'danger' | 'warning' | 'default'
}

export function ConfirmationModal({
    title = 'Confirm',
    message,
    confirmText = 'Yes',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    type = 'default',
}: ConfirmationModalProps) {
    const confirmBtnClass =
        type === 'danger' ? 'btn btn-danger'
        : type === 'warning' ? 'btn btn-warning'
        : 'btn btn-primary'

    return createPortal(
        <div className="aps-background-mask mask-is-active">
            <div
                className="modal fade in"
                style={{ display: 'block', zIndex: 1050 }}
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{title}</h4>
                        </div>
                        <div className="modal-body">
                            <p>{message}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-default"
                                onClick={onCancel}
                            >
                                {cancelText}
                            </button>
                            <button
                                type="button"
                                className={confirmBtnClass}
                                onClick={onConfirm}
                            >
                                {confirmText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    )
}
